import { render } from "./LatestThreePeriod.vue?vue&type=template&id=2615d0db&scoped=true"
import script from "./LatestThreePeriod.vue?vue&type=script&lang=js"
export * from "./LatestThreePeriod.vue?vue&type=script&lang=js"

import "./LatestThreePeriod.vue?vue&type=style&index=0&id=2615d0db&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2615d0db"]])

export default __exports__